import React from 'react';

/**
 * Loading spinner component with customizable size
 * @param {Object} props - Component props
 * @param {string} props.size - Size of the spinner (sm, md, lg)
 * @param {string} props.color - Color of the spinner (white, black)
 */
const LoadingSpinner = ({ size = 'md', color = 'white' }) => {
  // Size mappings
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-2',
    lg: 'h-12 w-12 border-3',
  };
  
  // Color mappings
  const colorClasses = {
    white: 'border-white border-t-transparent',
    black: 'border-black border-t-transparent',
  };
  
  return (
    <div className={`animate-spin rounded-full ${sizeClasses[size] || sizeClasses.md} ${colorClasses[color] || colorClasses.white}`}></div>
  );
};

export default LoadingSpinner; 